
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#0C1D59","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2 13h6.062A8.001 8.001 0 0024 12a8 8 0 00-15.938-1H2a1 1 0 10-2 0v2a1 1 0 102 0zm9.17 2.45A5.989 5.989 0 0110.093 13H11a1 1 0 100-2h-.907a5.99 5.99 0 011.077-2.45c.727-.982 1.611-1.559 2.315-1.735.603-.15 1.039-.028 1.425.429C15.407 7.832 16 9.209 16 12c0 2.791-.593 4.168-1.09 4.756-.386.457-.822.58-1.425.429-.704-.176-1.588-.753-2.315-1.735zm5.323-9.43C17.4 7.14 18 9.06 18 12c0 2.94-.6 4.86-1.507 5.98a6 6 0 000-11.96z"}})])
          )
        }
      }
    